import styled, { css } from 'styled-components';
import { FlexBetween } from '../../../styled/common';
import { Typography } from '../Typography';
import { CheckboxProps } from './types';

export const CheckboxMark = styled.span`
  position: relative;
  display: inline-block;
  min-width: 20px;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  transition:
    background-color 0.1s ease-in-out,
    border-color 0.2s ease-in-out;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.background.primary};
  background-repeat: no-repeat;
  background-position: center;
`;

export const CheckboxLabel = styled(Typography)<{
  $isGroupCheckbox: boolean;
}>`
  ${({ $isGroupCheckbox }) =>
    $isGroupCheckbox &&
    css`
      color: ${({ theme }) => theme.colors.systemColors.blue};
    `}
`;

export const CheckboxLabelContainer = styled.label<{ isLongName: boolean }>`
  display: block;
  height: 44px;
  -webkit-tap-highlight-color: transparent;

  ${({ isLongName }) =>
    isLongName &&
    css`
      height: max-content;
    `};

  @media (hover: hover) {
    &:hover {
      ${CheckboxMark} {
        border-color: ${({ theme }) => theme.colors.systemColors.blue};
      }

      ${CheckboxLabel} {
        color: ${({ theme }) => theme.colors.systemColors.blue};
      }
    }
  }
`;

export const CheckboxContainer = styled(FlexBetween)<
  Pick<CheckboxProps, 'markAlign'> & { isLongName: boolean }
>`
  height: 44px;
  cursor: pointer;

  ${({ markAlign }) =>
    markAlign === 'left' &&
    css`
      flex-direction: row-reverse;
      justify-content: flex-end;
      gap: 10px;
    `}

  ${({ isLongName }) =>
    isLongName &&
    css`
      align-items: flex-start;
      height: max-content;
    `}
`;

const tickMark =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEyIDEwIj4gICAgPHBhdGggZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iLjkiIGQ9Ik0xMS4zNzQgMWwtNy4wNiA2Ljc5NkwuNjI1IDQuMjQ3IDAgNC44NDkgNC4zMTMgOSAxMiAxLjYwMnoiLz48L3N2Zz4=';

export const CheckboxInput = styled.input`
  opacity: 0;
  visibility: hidden;
  position: absolute;
  z-index: -1;

  &:checked {
    ~ ${CheckboxMark} {
      background-image: url(${tickMark});
      background-color: ${({ theme }) => theme.colors.systemColors.blue};
      border-color: ${({ theme }) => theme.colors.systemColors.blue};
    }
  }
`;

export const CheckboxAdditionalLabel = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-left: 3px;
  text-transform: lowercase;
`;
